module.exports = __webpack_public_path__ + "static/media/4. Pétalos, Resina epóxica sobre hierro, 60 x 65 x 54 cm, 2020 copy.1aad7118.png";